// =============================================================================
// reminders-client.ts — Client API de la RELANCE MANUELLE admin (BC campaign), DOUBLABLE.
// =============================================================================
// A-16 / V-SUIVI-FOURN-relance (DBU §2.5 l.1171/1173, UC-A-048). Miroir de l'endpoint ADMIN
// POST /api/admin/campaigns/:campaignId/reminders (AdminSessionGuard). Comme les autres clients UI, expose
// une INTERFACE consommée par un hook TanStack ; l'impl HTTP réelle (fetch) est substituable via le DI seam
// (RemindersClientProvider) sans toucher l'UI (stub-first).
//
// AUTORITÉ = API + WORKER : l'API RÉSOUT la cohorte (SIRET publics) et RELAIE une demande INFRA ; le worker
// FILTRE les non-soumis sous withTenant, envoie Postmark CCI (un envoi séparé par SIRET, anti-fuite l.372) et
// émet DE.ReminderSent(actor=admin, milestone=manual). L'UI DÉCLENCHE et habille — aucune règle métier ici.

import { HttpApiError } from '@/api/http-error';

/** Mode de ciblage de la relance (DBU l.1171/1173). */
export type ReminderMode = 'individual' | 'group' | 'siren';

/** Commande de relance (validée côté API). Un seul des `sirets` (individual) / `siren` (siren) est requis. */
export interface SendRemindersInput {
  readonly campaignId: string;
  readonly mode: ReminderMode;
  /** Cycle dont l'échéance est relancée (entier positif). */
  readonly cycle: number;
  /** Mode `individual` : SIRET sélectionnés (14 chiffres). */
  readonly sirets?: readonly string[];
  /** Mode `siren` : SIREN ciblé (9 chiffres). */
  readonly siren?: string;
  /**
   * SUJET éditable de la relance (R15-COM-05 / DBU §2.7.1 l.1508 « Édition du message type possible avant
   * envoi »). Optionnel : absent → sujet statique du template worker. Édité dans la modale de relance.
   */
  readonly subject?: string;
  /** CORPS éditable de la relance (R15-COM-05 / DBU §2.7.1 l.1508). Même régime que `subject`. */
  readonly body?: string;
}

/** Réponse : la demande a été RELAYÉE (le worker relance) + nb de SIRET ciblés. Miroir HTTP. */
export interface SendRemindersResultDto {
  readonly status: 'relayed';
  readonly campaignId: string;
  readonly targetedSiretCount: number;
}

/** Erreur du client Relance (conserve le statut HTTP — intercepteur 401 admin). */
export class RemindersApiError extends HttpApiError {
  public constructor(message: string, status?: number) {
    super(message, status, 'RemindersApiError');
  }
}

/** Interface DOUBLABLE : une seule commande (POST) — l'admin DÉCLENCHE, le worker relance. */
export interface RemindersClient {
  sendReminders(input: SendRemindersInput): Promise<SendRemindersResultDto>;
}
